import type { Dict } from '../index.js';
import { common } from './common.js';
import { people } from './people.js';
import { leave } from './leave.js';
import { attendance } from './attendance.js';
import { productivity } from './productivity.js';
import { settings } from './settings.js';
import { server } from './server.js';
import { payroll } from './payroll.js';
import { labels } from './labels.js';
import { phase9 } from './phase9.js';
import { bank } from './bank.js';

/** Arabic dictionary, split by area of the app. */
export const AR: Dict = { ...bank, ...phase9, ...labels, ...server, ...settings, ...payroll, ...productivity, ...attendance, ...leave, ...people, ...common };
